import * as Yup from "yup";
import dayjs from "dayjs";

export const rackTypes = {
    normal: "normal",
    reserve: "reserve"
}

export const validateRowSchema = Yup.object().shape({
    name: Yup
        .string()
        .required("Required"),
    rackId: Yup
        .string()
        .required("Required"),
    slotId: Yup
        .string()
        .required("Required"),
    rowFromType: Yup
        .mixed()
        .oneOf(Object.keys(rackTypes))
        .required("Required"),
    rowToType: Yup
        .mixed()
        .oneOf(Object.keys(rackTypes))
        .required("Required"),
    qty: Yup.lazy((val) => {

        let maxQty = val?.maxQty ? val.maxQty : 0

        let valueSchema;

        valueSchema = Yup
            .number("")
            .typeError("Invalid")
            // .min(parseFloat(minQty))
            .max(parseFloat(maxQty), `Max : ${maxQty}`)
            .positive("More than 0")
            .required("Required")

        return Yup.object().shape({
            value: valueSchema,
            maxQty: Yup.mixed().nullable().typeError("Invalid"),
        })


    }),
})

export const validationSchema = Yup.object({
    documentDate: Yup
        // .string()
        .date("Invalid")
        .required("Required")
        .typeError("Invalid"),
    locationId: Yup
        .string()
        .required("Required"),
    rows: Yup.array().of(validateRowSchema)
})

export const initialRowValues = {
    docItemId: 0,
    name: "",
    code: "",
    uomName: "",
    uomId: "",
    isDefaultUom: false,
    transformRatio: 0,
    productId: "",
    decription: "",
    inventoryBatchId: "",
    inventoryCustomBatchNo: "",
    inventoryExpiryDate: "",
    rowFromType: rackTypes.normal,
    rowToType: rackTypes.normal,
    rackId: "",
    slotId: "",
    qty: {
        value: "",
        maxQty: 0,
    },
    price: 0,
    props: {
        relocate_slot: ""
    },
    deductions: {
        slot_id: "",
        custom_batch_no: "",
        expiry_date: ""
    },
    isAutoTransform: false
}

export const initialValues = {
    documentDate: dayjs(),
    rows: [initialRowValues],
    totalqty: "0",
    locationId: "",
    locationName: "",
    isConfirm: false,
    confirmDateTime: "",
}
